module.exports = __webpack_public_path__ + "static/media/56.c0c47d1a.png";